<!--  -->
<template>
  <div>
    <div class="infoPaddingCss">
      <div>
        <div class="flexButton">
          <span class="fontWeight">订单信息</span>
          <div
              v-if="isHavePermission('global:viewCreateTime')"
            style="color: #a7adad"
          >结算编号: {{deailReceiveNum}} | 客户经理: {{deailCreateUser}} | 创建日期: {{deailCreateTime | timePartRule}}</div>
          <div
              v-else
            style="color: #a7adad"
          >结算编号: {{deailReceiveNum}} | 客户经理: {{deailCreateUser}}</div>
        </div>
        <vxe-table auto-resize border="inner" :data="orderTableData" align="center">
          <vxe-table-column field="chainNum" title="主订单编号" show-overflow>
            <template slot-scope="{ row }">
              <a @click="showChainDetail(row)">{{ row.chainNum }}</a>
            </template>
          </vxe-table-column>
          <vxe-table-column field="ordersSellerLv2Num" title="子订单编号" show-overflow>
            <template slot-scope="{ row }">
              <a @click="showSellerDetail(row)">{{ row.ordersSellerLv2Num}}</a>
            </template>
          </vxe-table-column>
          <vxe-table-column field="buyerName" title="托运人名称"></vxe-table-column>
          <vxe-table-column field="compName" title="平台企业"></vxe-table-column>
          <vxe-table-column field="sellerName" title="承运人名称"></vxe-table-column>
          <vxe-table-column field="sendName" title="实际承运人名称"></vxe-table-column>
        </vxe-table>
      </div>
      <div style="margin-top: 10px;">
        <div class="flexButton">
          <span class="fontWeight">物流信息</span>
        </div>
        <vxe-table
          auto-resize
          border="inner"
          :data="logisticsShowData"
          stripe
          highlight-hover-row
          align="center"
        >
          <vxe-table-column field="id" title="序号"></vxe-table-column>

          <vxe-table-column field="logisticsNum" title="物流编号" show-overflow>
            <template slot-scope="{ row }">
              <span
                @click="showLogisticsDetail(row)"
                style="cursor:pointer;color: #2d8cf0;"
              >{{ row.logisticsNum }}</span>
            </template>
          </vxe-table-column>
          <vxe-table-column field="logisticsCode" title="物流单号" show-overflow></vxe-table-column>
          <vxe-table-column field="goodsName" title="货物名称" show-overflow></vxe-table-column>
          <vxe-table-column field="goodsRule" title="规格"></vxe-table-column>
          <vxe-table-column field="realCount" title="实际数量"></vxe-table-column>
          <vxe-table-column field="goodsUnit" title="单位"></vxe-table-column>
          <vxe-table-column field="carShipNum" title="车船号" show-overflow>
            <template slot-scope="{ row }">
              <span
                v-if="row.trackUrl || row.logisticsType === 2"
                @click="getMap(row)"
                style="color: #2D8CF0;cursor:pointer"
              >{{ row.carShipNum }}</span>
              <span v-if="!row.trackUrl && row.logisticsType !== 2 ">{{ row.carShipNum }}</span>
            </template>
          </vxe-table-column>
          <vxe-table-column field="voyage" title="航次号" show-overflow></vxe-table-column>
          <vxe-table-column field="deliveryPlace" title="交货地点" show-overflow></vxe-table-column>
          <vxe-table-column field="beginPlace" title="起运地" show-overflow></vxe-table-column>
          <vxe-table-column field="beginTime" title="起运时间" width="100">
            <template slot-scope="{ row }">
              <span style="color: #a7adad">{{ row.beginTime | timePartRule }}</span>
            </template>
          </vxe-table-column>
          <vxe-table-column field="endPlace" title="到达地"></vxe-table-column>
          <vxe-table-column field="endTime" title="到达时间" width="100">
            <template slot-scope="{ row }">
              <span style="color: #a7adad">{{ row.endTime | timePartRule }}</span>
            </template>
          </vxe-table-column>
        </vxe-table>
        <vxe-pager
          background
          size="small"
          :current-page.sync="currentPage2"
          :page-size.sync="pageSize2"
          :total="totalResult2"
          @page-change="handleCurrentChange2"
        ></vxe-pager>
      </div>
      <div style="margin-top: 10px;" class="infoPaddingCss">
        <div class="flexButton">
          <span class="fontWeight">结算信息</span>
        </div>
        <vxe-table
          auto-resize
          border="inner"
          align="center"
          :data="receivingTableData"
          :edit-config="{trigger: 'click', mode: 'cell'}"
        >
          <vxe-table-column field="addTime" title="结算时间">
            <template v-slot="{ row }">
              <span>{{ row.addTime | timePartRule }}</span>
            </template>
          </vxe-table-column>
          <vxe-table-column field="goodsName" title="货名" show-overflow>
            <template v-slot="{row}">
              <span>{{ row.goodsName}}</span>
            </template>
          </vxe-table-column>
          <vxe-table-column field="goodsRule" title="规格">
            <template v-slot="{row}">
              <span>{{ row.goodsRule}}</span>
            </template>
          </vxe-table-column>
          <vxe-table-column field="goodsUnit" title="单位">
            <template v-slot="{row}">
              <span>{{ row.goodsUnit}}</span>
            </template>
          </vxe-table-column>
          <vxe-table-column field="counts" title="实际交接数量">
            <template v-slot="{row}">
              <span>{{ row.counts}}</span>
            </template>
          </vxe-table-column>
          <vxe-table-column field="price" title="单价" show-overflow>
            <template v-slot="{row}">
              <span>{{ row.price}}</span>
            </template>
          </vxe-table-column>
          <vxe-table-column field="receAmount" title="总金额">
            <template v-slot="{row}">
              <span>{{ row.receAmount}}</span>
            </template>
          </vxe-table-column>
          <vxe-table-column field="note" title="摘要" show-overflow>
            <template v-slot="{row}">
              <span>{{ row.note}}</span>
            </template>
          </vxe-table-column>
        </vxe-table>
      </div>
      <div class="add-box">
        <vxe-table
          border
          show-overflow
          :auto-resize="true"
          class="table-upload-style"
          max-height="200"
          :data="uploadData"
          :edit-config="{trigger: 'click', mode: 'cell'}"
        >
          <vxe-table-column field="url" title="查看附件">
            <template v-slot="{row}">
              <upload-list :isEdit="false" :row="row" :initFileList="uploadList" :view="'arrange'"></upload-list>
            </template>
          </vxe-table-column>
        </vxe-table>
      </div>
    </div>
    <vxe-modal
      v-model="logisticDetailVisible"
      title="物流详情"
      width="1300"
       position="center"
      height="600"
      resize
      footer-hide
    >
      <detail-modal ref="modalDetail"></detail-modal>
    </vxe-modal>
    <div v-show="trackFlag" class="trackBoxModal">
      <div style="display: flex;justify-content: space-between;">
        <div
          style="margin-left: 10px;font-size: 14px;font-weight: bold;line-height: 30px;"
        >{{isCar ? '车辆轨迹': '船舶轨迹'}}</div>
        <div
          @click="trackFlag = false"
          style="margin-right: 5px;cursor: pointer;line-height: 30px;height: 30px;background: #409EFF;color: #fff;border-radius:5px;width:60px;font-size: 12px;font-size: 12px;text-align: center;"
        >关闭</div>
      </div>
      <iframe
        ref="mapFrame"
        style="width:100%;height:91vh;overflow: hidden;"
        frameborder="0"
        name="showHere"
        scrolling="auto"
        :src="url"
      ></iframe>
      <!--      <iframe-view v-if="!isCar" :obj="shipObj"></iframe-view>-->
    </div>
  </div>
</template>

<script>
import $api from "@/apiProvider";
import auth from "@/utils/auth";
import Viewer from "viewerjs";
import "viewerjs/dist/viewer.css";
import DetailModal from "@/views/logistics/DetailModal";
import UploadList from "@/components/common/UploadList";
import moment from "moment";
import getAuthOrization from "../../mixin/getAuthOrization";

export default {
  components: {
    DetailModal,
    UploadList,
  },
  mixins: [getAuthOrization],
  data() {
    return {
      logisticsShowData: [],
      currentPage2: 1,
      pageSize2: 5,
      url: null,
      isCar: true,
      totalResult2: 300,
      receivingComp: null,
      trackFlag: false,
      deailReceiveNum: null,
      deailCreateUser: null,
      deailCreateTime: null,
      orderTableData: [],
      receivingTableData: [],
      logisticsTableData: [],
      logisticDetailVisible: false,
      showPicIndex: 0,
      uploadData: [
        {
          fileUuidList: [],
        },
      ],
      uploadList: [],
    };
  },
  filters: {
    timePartRule: function (t) {
      if (t) {
        var timeB = new Date(t);
        var y = 1900 + timeB.getYear();
        var m = "0" + (timeB.getMonth() + 1);
        var d = "0" + timeB.getDate();

        return (
          y +
          "-" +
          m.substring(m.length - 2, m.length) +
          "-" +
          d.substring(d.length - 2, d.length)
        );
      } else {
        return "";
      }
    },
  },
  methods: {
    async getReceivingDetail(row) {
      var self = this;
      self.currentPage2 = 1;
      self.pageSize2 = 5;
      self.receivingTableData = [];
      self.deailReceiveNum = row.receiveNum;
      self.deailCreateUser = row.createUser;

      self.deailCreateTime = row.createTime;
      self.orderTableData = [];
      self.editUuidList = [];
      self.uploadList = [];
      var objReceive = {};
      var objOrder = {};
      var data = {
        id: row.id,
      };
      let response = await $api.receiving.request(
        "querySellerLv2ReceiveGoodsDetail",
        data
      );
      if (response.status == 1) {
        let res = response.data;
        self.deailReceiveNum = res.receiveNum;
        self.deailCreateUser = res.updateUser;
        self.deailCreateTime = res.updateTime;
        //结算信息
        // objReceive.addTime = res.addTime;
        objReceive.addTime = this.$utils.toDateString(
          res.addTime,
          "yyyy-MM-dd"
        );
        self.receivingComp = res.compName;
        objReceive.goodsName = res.goodsName;
        objReceive.id = res.id;
        objOrder.chainNum = res.chainNum;
        objOrder.chainId = res.chainId;
        objReceive.goodsRule = res.goodsRule;
        objReceive.goodsUnit = res.goodsUnit;
        objReceive.counts = res.counts;
        objReceive.price = res.price;
        objReceive.receAmount = res.receAmount;
        objReceive.note = res.note;
        self.receivingTableData.push(objReceive);
        console.log(self.receivingTableData);
        //订单信息
        objOrder.ordersBuyerNum = res.ordersBuyerNum;
        objOrder.ordersSellerNum = res.ordersSellerNum;
        objOrder.ordersSellerLv2Num = res.ordersSellerLv2Num;
        self.orderNum = res.ordersSellerLv2Num;
        objOrder.receiveName = res.receiveName;
        objOrder.sendName = res.sendName;
        objOrder.createUser = res.createUser;
        objOrder.createTime = res.createTime;
        objOrder.ordersBuyerId = res.ordersBuyerId;
        objOrder.ordersSellerId = res.ordersSellerId;
        objOrder.ordersSellerLv2Id = res.ordersSellerLv2Id;
        objOrder.compName = res.compName;
        objOrder.sellerName = res.sellerName;
        objOrder.buyerName = res.buyerName;
        self.orderTableData.push(objOrder);
        //物流信息
        self.logisticsTableData = res.logisticsList;
        self.totalResult2 = self.logisticsTableData.length;
        self.logisticsShowData = self.logisticsTableData.slice(0, 5);
        //图片信息
        if (res.fileList != null) {
          res.fileList.map((i) => {
            self.editUuidList.push(i.uuid);
            self.uploadList.push(i);
          });
        }
      }
    },
    getMap(row) {
      if (row.logisticsType === 1) {
        this.isCar = true;
        this.seeCarMap(row);
      } else {
        this.isCar = false;
        this.seeShipMap(row);
      }
    },
    seeCarMap(row) {
      let that = this;
      this.trackFlag = true;
      this.url = '/carShip/fwCarFrame';
      this.$nextTick(function () {
        setTimeout(function () {
          let mapFrame = that.$refs.mapFrame;
          let iframeWin = mapFrame.contentWindow;
          iframeWin.postMessage(JSON.stringify({carInfo: row, logistics: true, top: true}), '*');
        }, 5000);
      });
    },
    handleCurrentChange2(val) {
      this.logisticsShowData = this.logisticsTableData.slice(
        (val.currentPage - 1) * val.pageSize,
        val.currentPage * val.pageSize
      );
      console.log(this.logisticsShowData);
    },
    seeShipMap(row) {
      let mmsi = row.mmsi ? row.mmsi : row.carShipNum;
      if (mmsi == null || mmsi === '') {
        //暂无数据
        this.$Message.error('暂无数据');
        return
      }
      let beginTime = moment(row.beginTime).format("YYYY-MM-DD");
      let deliveryDates = moment(row.endTime).format("YYYY-MM-DD")
      let obj = {
        startTime: beginTime + " 00:00:00",
        endTime: deliveryDates + " 00:00:00",
        mmsi: mmsi
      }
      this.trackFlag = true;
      let that = this;
      if (this.url === '/carShip/fwShipFrame') {
        let mapFrame = that.$refs.mapFrame;
        let iframeWin = mapFrame.contentWindow
        iframeWin.postMessage(JSON.stringify(obj), '*')
      } else {
        this.url = '/carShip/fwShipFrame';
        this.$nextTick(function () {
          setTimeout(function () {
            let mapFrame = that.$refs.mapFrame;
            let iframeWin = mapFrame.contentWindow
            iframeWin.postMessage(JSON.stringify(obj), '*')
          }, 5000);
        });
      }
    },
    // 船舶日期往前推N天
    dateAddDays(dataStr, dayCount) {
      let isdate = new Date(dataStr.replace(/-/g, "/"));
      isdate = new Date((isdate / 1000 - 86400 * dayCount) * 1000); //日期-N天
      let strMonth = isdate.getMonth() + 1;
      let strDate = isdate.getDate();
      let strYear = isdate.getFullYear();
      if (strMonth >= 1 && strMonth <= 9) {
        strMonth = "0" + strMonth;
      }
      if (strDate >= 1 && strDate <= 9) {
        strDate = "0" + strDate;
      }
      return strYear + "-" + strMonth + "-" + strDate;
    },
    showLogisticsDetail(row) {
      if (!this.isHavePermission('logistics:queryLogisticsDetail')){
        this.$Message["info"]({
          background: true,
          content: "对不起，您没有该权限！"
        });
        return ;
      }
      this.logisticDetailVisible = true;
      this.$refs.modalDetail.queryLogisticsDetail(row.id);
    },
    clickFile(url) {
      window.open(url);
    },
    showChainDetail(row) {
      if (!this.isHavePermission('chain:detail')){
        this.$Message["info"]({
          background: true,
          content: "对不起，您没有该权限！"
        });
        return ;
      }
      this.$router.push(`/order/detail/${row.chainId}`);
      this.$emit("closeRec", false);
    },
    showSellerDetail(row) {
      if (!this.isHavePermission('sellerLv2:detail')){
        this.$Message["info"]({
          background: true,
          content: "对不起，您没有该权限！"
        });
        return ;
      }
      this.$router.push(`/order/secseller/detail/${row.ordersSellerLv2Id}`);
      this.$emit("closeRec", false);
    },
  },
};
</script>
<style>
.trackBoxModal {
  width: 100%;
  height: 100vh;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 999;
  background: #fff;
}
/* .flexButton {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
} */
.pdf-box1 {
  display: inline-block;
  position: relative;
  line-height: 60px;
  background-color: rgba(0, 0, 0, 0.8);
  color: white;
  width: 60px;
  height: 60px;
  overflow: hidden;
}
.infoPaddingCss .vxe-pager .vxe-pager--sizes {
  width: 7em;
  text-align: center;
  cursor: pointer;
  display: none;
}
</style>
